import { useState, useRef, useEffect } from "react";
import { getDisbursmentOtpSendByDataVerify } from "../../containers/Admin/AdminActionCreator.component";

const OTPPopup = ({ OTPpopup, OpenOTPPopup,netAmountValue, admin }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [status, setStatus] = useState("idle");
    const [shake, setShake] = useState(false);
    const inputsRef = useRef([]);


    useEffect(() => {
        if (OTPpopup) {
            setOtp(["", "", "", "", "", ""]);
            setStatus("idle");
            setIsOpen(true);
        } else {
            setIsOpen(false);
            setStatus("idle");
        }
    }, [OTPpopup])

    const open = () => {
        setOtp(["", "", "", "", "", ""]);
        setStatus("idle");
        setIsOpen(true);
    };

    const close = () => {
        OpenOTPPopup(false, false)
        setStatus("idle");
    };

    useEffect(() => {
        if (isOpen) setTimeout(() => inputsRef.current[0]?.focus(), 120);
    }, [isOpen]);

    const focusCell = (idx) => inputsRef.current[idx]?.focus();

    const handleChange = (e, idx) => {
        const val = e.target.value.replace(/\D/g, "");
        if (!val) return;
        const char = val[val.length - 1];
        const next = [...otp];
        next[idx] = char;
        setOtp(next);
        if (idx < 5) focusCell(idx + 1);
    };

    const handleKeyDown = (e, idx) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            if (otp[idx]) {
                const next = [...otp];
                next[idx] = "";
                setOtp(next);
            } else if (idx > 0) {
                const next = [...otp];
                next[idx - 1] = "";
                setOtp(next);
                focusCell(idx - 1);
            }
        } else if (e.key === "ArrowLeft" && idx > 0) {
            e.preventDefault();
            focusCell(idx - 1);
        } else if (e.key === "ArrowRight" && idx < 5) {
            e.preventDefault();
            focusCell(idx + 1);
        } else if (e.key === "Enter") {
            handleVerify();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
        if (!pasted) return;
        const next = ["", "", "", "", "", ""];
        pasted.split("").forEach((ch, i) => { next[i] = ch; });
        setOtp(next);
        const nextFocus = Math.min(pasted.length, 5);
        setTimeout(() => focusCell(nextFocus), 0);
    };

    const handleVerify = () => {
        const code = otp.join("");
        if (code.length < 6) {
            setShake(true);
            setTimeout(() => setShake(false), 600);
            return;
        }
        setStatus("loading");
        setTimeout(() => {
            const str =  `empId=${admin?.emailId}&otp=${code}&type=${netAmountValue}`
         
            getDisbursmentOtpSendByDataVerify(str, callback => {
                console.log("call",callback)
                if (callback?.status == 200) {
                    setStatus("success");
                    OpenOTPPopup(false, true)
                } else {
                    setStatus("error");
                    setShake(true);
                    setTimeout(() => setShake(false), 600)
                }
            })

        }, 1200);
    };

    const handleFocus = (e) => e.target.select();

    // ─── Light Theme Styles ────────────────────────────────────────────────────

    const overlay = {
        position: "fixed", inset: 0,
        background: "rgba(100, 116, 139, 0.35)",
        backdropFilter: "blur(8px)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000,
        animation: "fadeIn .18s ease",
    };

    const card = {
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "24px",
        padding: "44px 40px 36px",
        width: "min(420px, 92vw)",
        boxShadow: "0 20px 60px rgba(15,23,42,0.12), 0 4px 16px rgba(15,23,42,0.06)",
        position: "relative",
        animation: "popIn .22s cubic-bezier(.34,1.56,.64,1)",
    };

    const closeBtn = {
        position: "absolute", top: "16px", right: "18px",
        background: "#f1f5f9",
        border: "1px solid #e2e8f0",
        borderRadius: "50%", width: "32px", height: "32px",
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", color: "#94a3b8", fontSize: "14px",
        transition: "all .18s",
    };

    const iconWrap = {
        width: "52px", height: "52px",
        background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
        border: "1px solid #bfdbfe",
        borderRadius: "16px",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: "22px", marginBottom: "20px",
    };

    const title = {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: "22px", fontWeight: 800,
        color: "#0f172a", margin: "0 0 6px",
        letterSpacing: "-0.3px",
    };

    const subtitle = {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: "13.5px", color: "#94a3b8",
        margin: "0 0 28px", lineHeight: 1.6,
    };

    const divider = {
        height: "1px",
        background: "linear-gradient(90deg, transparent, #e2e8f0, transparent)",
        margin: "0 0 24px",
    };

    const inputRow = {
        display: "flex", gap: "10px", justifyContent: "center",
        marginBottom: "24px",
        animation: shake ? "shake .5s ease" : "none",
    };

    const cellBase = (val) => {
        const filled = val !== "";
        const isErr = status === "error";
        const isOk = status === "success";

        let bg = filled ? "#f8faff" : "#f8fafc";
        let border = filled ? "#3b82f6" : "#e2e8f0";
        let color = "#0f172a";
        let shadow = filled ? "0 0 0 3px rgba(59,130,246,0.12)" : "none";

        if (isErr && filled) { bg = "#fff5f5"; border = "#ef4444"; color = "#ef4444"; shadow = "0 0 0 3px rgba(239,68,68,0.1)"; }
        if (isOk && filled) { bg = "#f0fdf4"; border = "#22c55e"; color = "#16a34a"; shadow = "0 0 0 3px rgba(34,197,94,0.1)"; }

        return {
            width: "52px", height: "60px",
            background: bg,
            border: `2px solid ${border}`,
            borderRadius: "14px",
            textAlign: "center",
            fontSize: "24px", fontWeight: 700,
            color,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            outline: "none",
            caretColor: "#3b82f6",
            transition: "border .15s, background .15s, box-shadow .15s",
            boxShadow: shadow,
            cursor: "text",
        };
    };

    const verifyBtn = {
        width: "100%", padding: "14px",
        background: status === "success"
            ? "linear-gradient(135deg, #16a34a, #22c55e)"
            : status === "loading"
                ? "#93c5fd"
                : "linear-gradient(135deg, #2563eb, #3b82f6)",
        border: "none", borderRadius: "14px",
        color: "#fff", fontSize: "15px", fontWeight: 700,
        fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: "0.2px",
        cursor: status === "loading" ? "not-allowed" : "pointer",
        transition: "all .2s",
        boxShadow: status === "success"
            ? "0 6px 20px rgba(34,197,94,0.28)"
            : status === "loading"
                ? "none"
                : "0 6px 20px rgba(37,99,235,0.28)",
        display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
    };

    const resendRow = {
        textAlign: "center", marginTop: "16px",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: "13px", color: "#94a3b8",
    };

    const resendLink = {
        color: "#2563eb", fontWeight: 600,
        cursor: "pointer", textDecoration: "none",
        background: "none", border: "none", fontSize: "13px",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
    };

    const hintBadge = {
        display: "inline-flex", alignItems: "center", gap: "5px",
        background: "#f0f9ff", border: "1px solid #bae6fd",
        borderRadius: "8px", padding: "4px 10px",
        fontSize: "11.5px", color: "#0369a1", fontWeight: 500,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        marginBottom: "16px",
    };

    return (
        <>
            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeIn { from { opacity:0 } to { opacity:1 } }
        @keyframes popIn { from { opacity:0; transform: scale(.93) translateY(14px) } to { opacity:1; transform: scale(1) translateY(0) } }
        @keyframes shake {
          0%,100% { transform: translateX(0) }
          15% { transform: translateX(-7px) }
          30% { transform: translateX(7px) }
          45% { transform: translateX(-5px) }
          60% { transform: translateX(5px) }
          75% { transform: translateX(-3px) }
          90% { transform: translateX(3px) }
        }
        @keyframes spin { to { transform: rotate(360deg) } }
        input[type=number]::-webkit-inner-spin-button,
        input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; }
        input[type=number] { -moz-appearance: textfield; }
        .otp-cell:focus {
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 4px rgba(59,130,246,0.18) !important;
          background: #eff6ff !important;
        }
        .close-x:hover { background: #e2e8f0 !important; color: #475569 !important; }
        .verify-btn:hover:not(:disabled) { transform: translateY(-1px); filter: brightness(1.06); }
        .resend-link:hover { text-decoration: underline !important; }
      `}</style>

          
            

            {/* Modal */}
            {isOpen && (
                <div style={overlay} onClick={(e) => e.target === e.currentTarget && close()}>
                    <div style={card}>
                        {/* Close button */}
                        <button className="close-x" style={closeBtn} onClick={close}>✕</button>

                        {/* Icon */}
                        <div style={iconWrap}>🔐</div>

                        {/* Title */}
                        <h2 style={title}>Verify your identity</h2>
                        <p style={subtitle}>
                            We sent a 6-digit code to XXXXXX1102.<br />
                            Enter it below to continue.
                        </p>

                        {/* <div style={divider} /> */}



                        {/* OTP inputs */}
                        <div style={{ ...inputRow }}>
                            {otp.map((val, idx) => (
                                <input
                                    key={idx}
                                    ref={(el) => (inputsRef.current[idx] = el)}
                                    className="otp-cell"
                                    type="number"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={val}
                                    style={cellBase(val)}
                                    onChange={(e) => handleChange(e, idx)}
                                    onKeyDown={(e) => handleKeyDown(e, idx)}
                                    onPaste={handlePaste}
                                    onFocus={handleFocus}
                                    autoComplete="one-time-code"
                                />
                            ))}
                        </div>

                        {/* Status messages */}
                        {status === "error" && (
                            <div style={{
                                display: "flex", alignItems: "center", gap: "7px",
                                background: "#fff5f5", border: "1px solid #fecaca",
                                borderRadius: "10px", padding: "10px 14px",
                                marginBottom: "16px", marginTop: "-8px",
                            }}>
                                <span style={{ fontSize: "15px" }}>✗</span>
                                <span style={{ fontSize: "13px", color: "#ef4444", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 500 }}>
                                    Incorrect code. Please try again.
                                </span>
                            </div>
                        )}
                        {status === "success" && (
                            <div style={{
                                display: "flex", alignItems: "center", gap: "7px",
                                background: "#f0fdf4", border: "1px solid #bbf7d0",
                                borderRadius: "10px", padding: "10px 14px",
                                marginBottom: "16px", marginTop: "-8px",
                            }}>
                                <span style={{ fontSize: "15px" }}>✓</span>
                                <span style={{ fontSize: "13px", color: "#16a34a", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 500 }}>
                                    Identity verified successfully!
                                </span>
                            </div>
                        )}

                        {/* Verify button */}
                        <button
                            className="verify-btn"
                            style={verifyBtn}
                            onClick={handleVerify}
                            disabled={status === "loading" || status === "success"}
                        >
                            {status === "loading" && (
                                <span style={{
                                    width: "16px", height: "16px",
                                    border: "2.5px solid rgba(255,255,255,0.4)",
                                    borderTopColor: "#fff", borderRadius: "50%",
                                    display: "inline-block",
                                    animation: "spin .7s linear infinite",
                                }} />
                            )}
                            {status === "success" ? "✓  Verified!" : status === "loading" ? "Verifying…" : "Verify Code →"}
                        </button>

                        {/* Resend */}
                        {/* <div style={resendRow}>
                            Didn't receive the code?{" "}
                            <button
                                className="resend-link"
                                style={resendLink}
                                onClick={() => { setOtp(["", "", "", "", "", ""]); setStatus("idle"); setTimeout(() => focusCell(0), 0); }}
                            >
                                Resend OTP
                            </button>
                        </div> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default OTPPopup;